import styled from 'styled-components'
import { COLORS } from 'consts/colors'
import RemoveSvg from 'assets/svgr-icons/Remove.svg'

export const PreviewContainer = styled.div`
  position: relative;
  width: 100%;
  min-height: 200px;
  border-radius: 4px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${COLORS.primaryExtraLight};
`

export const PreviewImage = styled.img`
  max-width: 100%;
  max-height: 200px;
  object-fit: contain;
  display: block;
  border-radius: 4px;
`

export const DeleteButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 0;
  border: 1px solid ${COLORS.borderColor};
  border-radius: 4px;
  background-color: ${COLORS.white};
  cursor: pointer;
  transition: background-color 0.15s ease;
`

export const DeleteIcon = styled(RemoveSvg)`
  width: 12px;
  height: 12px;

  path {
    fill: ${COLORS.secondaryDark};
  }
`

export const LoadingOverlay = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${COLORS.primaryExtraLight};
`
